import React, { PureComponent } from 'react';
import Stats from 'frontend_stats';

import ReviewMarkup, { reviewProps } from './ReviewMarkup';

class Review extends PureComponent {
	disAllowsHover = true

	state = {
		helpful: false,
		report: false,
		report_confirm: false,
		hoveredOver: this.disAllowsHover,
	}

	componentDidMount() {
		this.disAllowsHover = window.matchMedia("(any-hover: none)").matches;
		this.setState({ hoveredOver: this.disAllowsHover });
	}

	trackEvent(name) {
		Stats.trackGeneric('review_feedback', {
			step_name: name,
		});
	}

	handleHelpful = triggerLoginModal => () => {
		const { isCustomer, onFeedback } = this.props;
		if (!isCustomer) {
			this.trackEvent('logged_out');
			return triggerLoginModal();
		}
		onFeedback('helpful');
		this.setState({ helpful: true });
	};

	handleReport = (e, triggerLoginModal) => {
		e && e.preventDefault();
		const { report } = this.state;
		const { isCustomer, onFeedback } = this.props;
		if (!isCustomer) {
			this.trackEvent('logged_out');
			return triggerLoginModal();
		}
		report && onFeedback('report');
		this.setState({
			report: true,
			// only set confirm to true if report already was true
			report_confirm: report,
		});
	};

	onClickEdit = () => {
		const reviewId = this.props.id;
		const { title, body, rating, shipping, quality, curation, images, onEditReview } = this.props;
		onEditReview(reviewId, title, body, rating, shipping, quality, curation, images);
	};

	handleHover = (isOver) => () => {
		this.setState({ hoveredOver: this.disAllowsHover || isOver });
	};

	onReportClose = () => this.setState({ report: false });

	render() {
		const passedProps = {
			...this.props,
			...this.state,
			handleHover: this.handleHover,
			onClickEdit: this.onClickEdit,
			handleReport: this.handleReport,
			onReportClose: this.onReportClose,
			handleHelpful: this.handleHelpful,
		};

		return (
			<ReviewMarkup {...passedProps} />
		);
	}
}

Review.propTypes = reviewProps;

Review.defaultProps = {
	authorIsCurrentCustomer: false,
	visibleWordCount: 250,
};

export default Review;
